import { render, staticRenderFns } from "./controlOverInvoices.vue?vue&type=template&id=24bc0476&scoped=true&"
import script from "./controlOverInvoices.vue?vue&type=script&lang=js&"
export * from "./controlOverInvoices.vue?vue&type=script&lang=js&"
import style0 from "./controlOverInvoices.vue?vue&type=style&index=0&id=24bc0476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc0476",
  null
  
)

export default component.exports